// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ae43fae","874":"b07e2693","937":"06702803"}[chunkId] + ".chunk.js";
};